module.exports = __webpack_public_path__ + "assets/img/2-4.5f05b070.png";